import Skeleton from "react-loading-skeleton";

export const OvertimeScheduleTableSkeleton = () => {
  return (
    <table className="table table-borderless mb-0">
      <thead>
        <tr>
          {Array.from({ length: 8 }).map((_, index) => (
            <th key={index}>
              <Skeleton height={16} width={90} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 6 }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: 8 }).map((__, colIndex) => (
              <td key={`${rowIndex}-${colIndex}`}>
                <Skeleton height={14} width={colIndex === 0 ? 140 : 70} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
